import {Client} from "@/endpoints/rutsolve/gql/resolvers/client"
import {
    Supplier as SupplierModel,
    CreateSupplierDocument,
    UpdateSupplierDocument,
    SupplierInput,
    SupplierResponse,
    SupplierSelectorDocument,
    CreateSupplierMutationVariables,
    SupplierSelectorQueryVariables,
    UpdateSupplierMutationVariables,
    SupplierSummaryQueryVariables,
    SupplierSummaryDocument,
    RemoveSupplierMutationVariables,
    RemoveSupplierDocument,
} from "@/endpoints/rutsolve/gql/generated/graphql"

export class Supplier extends Client {
    constructor() {
        super()
    }

    public async summary(supplierID: string): Promise<SupplierModel> {
        try {
            const variables: SupplierSummaryQueryVariables = {
                supplierID: supplierID
            }
            const response = await this.client.request(SupplierSummaryDocument, variables)
            return response.supplier
        } catch (error) {
            this.handleError(error)
        }
    }

    public async selector(input?: SupplierInput): Promise<SupplierResponse> {
        try {
            const variables: SupplierSelectorQueryVariables = {
                input: input
            }
            const response = await this.client.request(SupplierSelectorDocument, variables)
            return response.suppliers
        } catch (error) {
            this.handleError(error)
        }
    }

    public async create(input: SupplierModel): Promise<string> {
        try {
            const variables: CreateSupplierMutationVariables = {
                input: {
                    memorandum: input.memorandum,
                    name: input.name,
                }
            }
            const response = await this.client.request(CreateSupplierDocument, variables)
            return response.createSupplier.id
        } catch (error) {
            this.handleError(error)
        }
    }

    public async update(input: SupplierModel) {
        try {
            const variables: UpdateSupplierMutationVariables = {
                input: {
                    id: input.id,
                    memorandum: input.memorandum,
                    name: input.name,
                }
            }
            await this.client.request(UpdateSupplierDocument, variables)
        } catch (error) {
            this.handleError(error)
        }
    }

    public async remove(supplierID: string) {
        try {
            const variables: RemoveSupplierMutationVariables = {
                supplierID: supplierID
            }
            await this.client.request(RemoveSupplierDocument, variables)
        } catch (error) {
            this.handleError(error)
        }
    }
}
